import React from 'react';
import { Instagram, Music2, MessageCircle, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#00382F] text-white py-12">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          
          {/* Logo and Brand */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl lg:text-3xl font-fraunces font-bold mb-2">
              Mobius Stories
            </h3>
            <p className="text-white/80 font-lato">
              Abadikan Momen Bahagiamu Bersama Kami
            </p>
          </div>

          {/* Social Media Icons */}
          <div className="flex items-center gap-6">

            {/* YouTube */}
            <a
              href="https://www.youtube.com/@mobiusstories"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 hover:bg-[#658C8D] flex items-center justify-center transition-all duration-300 hover:scale-110 group"
            >
              <Youtube
                size={24}
                className="text-white group-hover:scale-110 transition-transform duration-300"
              />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/mobiusstories/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 hover:bg-[#658C8D] flex items-center justify-center transition-all duration-300 hover:scale-110 group"
            >
              <Instagram
                size={24}
                className="text-white group-hover:scale-110 transition-transform duration-300"
              />
            </a>

            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@mobius.stories/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 hover:bg-[#658C8D] flex items-center justify-center transition-all duration-300 hover:scale-110 group"
            >
              <Music2
                size={24}
                className="text-white group-hover:scale-110 transition-transform duration-300"
              />
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/6285174247784"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 hover:bg-[#658C8D] flex items-center justify-center transition-all duration-300 hover:scale-110 group"
            >
              <MessageCircle
                size={24}
                className="text-white group-hover:scale-110 transition-transform duration-300"
              />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/20 text-center">
          <p className="text-white/70 font-lato text-sm">
            © {new Date().getFullYear()} Mobius Stories. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
